import React from "react";
import { Link } from "react-router-dom";
import { TiktokLogoIcon } from "@phosphor-icons/react";
import BidoraLogo from "@/components/BidoraLogo";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-200 bg-white mt-24 safe-bottom safe-x pb-32 md:pb-0">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12 grid md:grid-cols-4 gap-8">
        <div>
          <div className="mb-3">
            <BidoraLogo size={34} />
          </div>
          <p className="text-sm text-zinc-600 max-w-xs">
            Live auctions & marketplace. Verified sellers. Zero wholesale-to-retail crossover.
          </p>

          {/* Social — official Bidorah TikTok. opens in a new tab. */}
          <div className="mt-5 flex items-center gap-3">
            <span className="text-xs font-bold uppercase tracking-wider text-zinc-500">
              Follow
            </span>
            <a
              href="https://www.tiktok.com/@bidorahofficial"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Bidorah on TikTok"
              data-testid="footer-tiktok-link"
              className="group inline-flex items-center justify-center w-9 h-9 rounded-full bg-zinc-900 text-white hover:bg-[#1D78AB] transition-colors shadow-sm"
            >
              <TiktokLogoIcon size={18} weight="fill" />
            </a>
          </div>
        </div>
        <div>
          <p className="text-sm font-bold mb-3 text-zinc-900">Marketplace</p>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><Link to="/browse" className="hover:text-[#1D78AB]">Browse</Link></li>
            <li><Link to="/live" className="hover:text-[#1D78AB]">Live streams</Link></li>
            <li><Link to="/categories" className="hover:text-[#1D78AB]">Categories</Link></li>
            <li><Link to="/apply-to-sell" className="hover:text-[#1D78AB]">Apply to sell</Link></li>
            <li><Link to="/referrals" className="hover:text-[#1D78AB]">Referrals</Link></li>
          </ul>
        </div>
        <div>
          <p className="text-sm font-bold mb-3 text-zinc-900">Trust & Safety</p>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li><Link to="/policy" className="hover:text-[#1D78AB]">Wholesale Policy</Link></li>
            <li><Link to="/seller-guidelines" className="hover:text-[#1D78AB]">Seller Community Guidelines</Link></li>
            <li><Link to="/verify" className="hover:text-[#1D78AB]">ID verification</Link></li>
            <li>
              <Link to="/support" className="hover:text-[#1D78AB]" data-testid="footer-support-link">
                Contact support
              </Link>
            </li>
            <li>
              <Link
                to="/letter"
                className="hover:text-[#1D78AB]"
                data-testid="footer-founder-letter-link"
              >
                From the founder
              </Link>
            </li>
          </ul>
        </div>
        <div>
          <p className="text-sm font-bold mb-3 text-zinc-900">Legal</p>
          <ul className="space-y-2 text-sm text-zinc-600">
            <li>
              <Link
                to="/terms"
                className="hover:text-[#1D78AB]"
                data-testid="footer-terms-link"
              >
                Terms and Conditions
              </Link>
            </li>
            <li>
              <Link
                to="/notices"
                className="hover:text-[#1D78AB]"
                data-testid="footer-notices-link"
              >
                Trademarks & Notices
              </Link>
            </li>
          </ul>
        </div>
      </div>
      <div className="border-t border-zinc-200 py-5 px-6 text-xs text-zinc-500 max-w-7xl mx-auto">
        <p>
          © {new Date().getFullYear()} Bidorah. Bidorah and Bidoria are
          trademarks of Bidorah, Inc. All other product, brand, hashtag, and
          company names referenced anywhere on this site are the property of
          their respective owners — referenced for informational purposes only,
          with no affiliation, sponsorship, or endorsement implied.
        </p>
      </div>
    </footer>
  );
}
